if (!customElements.get('search-collections')) {
  class SearchCollections extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.loadCollections();
    }

    disconnectedCallback() {
      this.requestId = (this.requestId || 0) + 1;
      this.controller?.abort();
    }

    async loadCollections() {
      const query = this.dataset.query?.trim();
      const list = this.querySelector('[data-search-collections-list]');
      if (!query || !list || !this.dataset.predictiveUrl) return;

      const features = document.getElementById('shopify-features');
      if (features) {
        try {
          if (!JSON.parse(features.textContent).predictiveSearch) return;
        } catch {
          return;
        }
      }

      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const requestId = this.requestId = (this.requestId || 0) + 1;
      const timeout = setTimeout(() => controller.abort(), 7000);

      try {
        const url = new URL(this.dataset.predictiveUrl, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'collection');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[limit_scope]', 'all');
        url.searchParams.set('section_id', 'helper-predictive-search');
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);

        const response = await fetch(url, {
          credentials: 'same-origin',
          mode: 'same-origin',
          signal: controller.signal
        });
        if (!response.ok) return;
        const html = await response.text();
        if (!this.isConnected || requestId !== this.requestId || controller.signal.aborted) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fragment = document.createDocumentFragment();
        const seen = new Set();
        for (const source of parsed.querySelectorAll('a[data-search-collection]')) {
          const href = new URL(source.getAttribute('href'), window.location.origin);
          if (href.origin !== window.location.origin || !/(^|\/)collections\/[^/]+\/?$/.test(href.pathname) || seen.has(href.pathname)) continue;
          seen.add(href.pathname);
          const item = document.createElement('li');
          const link = source.cloneNode(true);
          link.className = 'kt-search-collections__link';
          link.removeAttribute('data-js-search-item');
          item.append(link);
          fragment.append(item);
          if (seen.size === 6) break;
        }

        list.replaceChildren(fragment);
        this.hidden = seen.size === 0;
      } catch {
        if (requestId === this.requestId) this.hidden = true;
      } finally {
        clearTimeout(timeout);
      }
    }
  }

  customElements.define('search-collections', SearchCollections);
}
